/**
 * Feature flag de la nouvelle interface de réservation (docs/ux-v2/SPEC.md § 6.1).
 *
 * `mondayMindbody.uxV2` n'est injecté par Frontend.php que si la v2 est active pour la requête
 * (case « Nouvelle interface de réservation (v2) » du BO, ou aperçu administrateur ?ux=v2) :
 * absent, l'app rend la v1 inchangée. Même forme que screens/Checkout/v2/flag.ts.
 */
export function isUxV2(): boolean {
  return typeof mondayMindbody !== 'undefined' && mondayMindbody?.uxV2?.enabled === true;
}

/** 'option' (case du BO), 'preview' (aperçu administrateur) ou null (v1). */
export function uxV2Source(): 'option' | 'preview' | null {
  if (!isUxV2()) return null;
  return mondayMindbody.uxV2?.source === 'preview' ? 'preview' : 'option';
}
